import './drag-scroll'

const attrConverter = (attributes = []) => {
  const props = {}
  for (let i = 0; i < attributes.length; i++) {
    const attr = attributes[i]
    const attrName = toCamelCase(attr.name)
    props[attrName] = attr.value
  }
  return props
}

const toCamelCase = str => str.replace(/-([a-z])/g, (m, p1) => p1.toUpperCase())

export default {
  attrConverter
}